
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { Row } from '@warrenbrasil/nebraska-web';
import { InstrumentName } from '@/modules/trade/components/InstrumentName';
import { InstrumentPrice } from '@/modules/trade/components/InstrumentPrice';

import { IPositionOptionItem } from '../../types';
import { Instrument } from '@/modules/trade/services/instruments';
import { PositionsColumns } from '@/modules/trade/services/instruments/enums';
import { useDashStore } from '@/modules/common/store/DashModule';

@Component({
  components: {
    InstrumentName,
    InstrumentPrice,
    Row
  }
})
export default class PositionItem extends Vue {
  private readonly dashModule = useDashStore();
  @Prop({ type: Object, required: true })
  readonly position!: Instrument;

  @Prop({ type: Object, required: true })
  readonly selectedOption!: IPositionOptionItem;

  @Prop({ type: String, required: true })
  readonly ariaLabel!: string;

  @Emit('on-position-click')
  emitPositionClick() {
    return this.position;
  }

  private showMoney: boolean = this.dashModule.showMoney;

  readonly PositionsColumns = PositionsColumns;

  get instrumentType() {
    return this.position.type?.value;
  }

  onPositionClick() {
    this.emitPositionClick();
  }
}
